export default __webpack_public_path__ + "77abaa096831b00140e4fb44e5ec9ecc.webp";